import React from "react";
import { Helmet } from "react-helmet";

const page = [
  { pathName: "rehberlik", pageName: "Rehberlik", defaultView: true },
  function () {
    return (
      <div className="subPages_hizmetlerimiz-rehberlik_wrap">
        <Helmet>
          <title>Kampüs Kreş - Rehberlik</title>
          <meta name="title" content="Kampüs Kreş - Rehberlik" />
          <meta property="og:title" content="Kampüs Kreş - Rehberlik" />
          <meta name="twitter:title" content="Kampüs Kreş - Rehberlik" />
        </Helmet>
        <div className="subPages_hizmetlerimiz-rehberlik_card">
          {/* <h1>Oryantasyon Çalışmaları</h1> */}
          <p>
            <strong>Kampüs Kreş’te</strong> sunulan rehberlik hizmetleri,
            öğrencilerimizin ve ailelerimizin okula ilk geldikleri andan
            itibaren başlar ve onların gelişim süreçlerine büyük katkı sağlar.{" "}
            <strong>0-6 yaş grubu</strong> çocuklar için gerçekleştirilen
            rehberlik çalışmaları, <strong>okul öncesi</strong> döneminde
            çocukların <strong>anaokulu</strong> ortamına uyum sağlama
            süreçlerinde oldukça önemli bir yer tutar.
            <br />
            <br />
            <strong>Kreş</strong> döneminde, çocukların evden ve ailelerinden
            ilk ayrılık deneyimlerini en sağlıklı şekilde yaşamaları için
            oryantasyon çalışmaları yapılmaktadır. Bu süreçte çocuğun{" "}
            <strong>anaokulu</strong>
            ve <strong>çocuk</strong> gelişimi açısından uygun olan okul
            ortamına ve öğretmenine yavaş yavaş alışması, güven duyması ve
            ihtiyaçlarını annesi dışında bir başka yetişkinin de
            karşılayabileceğini deneyimlemesi için gerekli çalışmalar
            yapılmaktadır.
            <br />
            <br />
            Oryantasyon süreciyle, çocukların{" "}
            <strong>okul öncesi eğitim</strong> ortamına ve öğretmenlerine
            alışmalarını kolaylaştırıyor, sınıf düzenini tanımalarına, sosyal
            beceriler geliştirmelerine ve duygusal farkındalık kazanmalarına
            olanak tanıyoruz.
            <br />
            <br />
            Okulumuzdaki rehberlik hizmetleri, öğrencilerimiz ve aileleriyle,
            okula ilk adım attıkları andan itibaren başlayan bir süreçtir ve
            çocukların gelişimlerine anlamlı katkılar sunar. Özellikle{" "}
            <strong>0-6 yaş grubu</strong> çocuklar için yürütülen rehberlik
            çalışmaları, <strong>Kampüs Kreş’in</strong> sunduğu{" "}
            <strong>çocuk gelişimi</strong> odaklı programlar dahilinde,{" "}
            <strong>kreş ve anaokulu</strong> ortamına uyum sürecinde önemli bir
            rol oynar.
            <br />
            <br />
            Bu yaş grubundaki çocukların, evlerinden ve ailelerinden ilk kez
            ayrıldıkları bu dönemde, süreci en sağlıklı şekilde yaşamaları adına
            oryantasyon çalışmaları titizlikle planlanmaktadır. Oryantasyon
            sürecinde; çocukların <strong>Kampüs Kreş</strong> ortamına ve
            öğretmenlerine yavaş yavaş alışmaları, güven geliştirmeleri ve
            ihtiyaçlarının anneleri dışında bir yetişkin tarafından da
            karşılanabileceğini deneyimlemeleri hedeflenir.
            <br />
            <br />
            Bu çalışmalar sayesinde çocukların <strong>
              kreş ve anaokulu
            </strong>{" "}
            ortamına daha kolay uyum sağlamaları, sınıf düzenini tanımaları,
            sosyal becerilerini geliştirmeleri ve duygusal farkındalık
            kazanmaları desteklenmektedir.
          </p>
        </div>
        <div className="subPages_hizmetlerimiz-rehberlik_card">
          <h1>Ölçme ve Değerlendirme</h1>
          <p>
            Çocukların <strong>çocuk gelişimi</strong> açısından gelişimsel
            düzeylerini daha iyi anlayabilmek amacıyla, okulumuzda çeşitli
            bilimsel temelli ölçme araçları kullanılmaktadır. Bu kapsamda,{" "}
            <strong>Kampüs Kreş</strong> rehberlik birimi tarafından{" "}
            <strong>Denver Gelişimsel Tarama Testi</strong> uygulanarak elde
            edilen bulgular ailelerle paylaşılır ve çocuğun gelişim süreci
            hakkında bilgilendirici raporlar sunulur.
            <br />
            <br />
            Bazı öğrencilerimizin özel gelişimsel ihtiyaçlarını daha yakından
            değerlendirebilmek adına, <strong>
              Frostig Görsel Algı Testi
            </strong>{" "}
            ve
            <strong>Gender-Gestalt</strong> gibi ölçme araçlarıyla çocukların
            bilişsel, motor ve sosyal becerileri analiz edilir. Bu testler,
            çocuğun güçlü yönlerini ve desteklenmesi gereken alanlarını ortaya
            koyarak rehberlik çalışmalarımızın daha verimli ve hedef odaklı
            yürütülmesine katkı sağlar.
            <br />
            <br />
            Ayrıca, ilkokula hazırlık sürecinde çocukların okula uyum
            yeterliliklerini değerlendirmek amacıyla{" "}
            <strong>İlkokula Hazırlık Bilişsel Olgunluk Testi</strong>{" "}
            uygulanmaktadır. Tüm bu çalışmaların yanı sıra, yıl boyunca yapılan
            düzenli gözlemler ve değerlendirme araçları ile çocukların{" "}
            <strong>çocuk gelişimi</strong> süreçleri{" "}
            <strong>Kampüs Kreş</strong> uzmanları tarafından titizlikle izlenir
            ve desteklenir.
          </p>
        </div>
        <div className="subPages_hizmetlerimiz-rehberlik_card">
          <h1>Gözlem ve Raporlama</h1>
          <p>
            <strong>Kampüs Kreş’te</strong>, tüm çocuklar psikoloğumuz
            tarafından sınıf ortamında dikkatle gözlemlenmektedir. Bu gözlemler
            sırasında; çocukların oyun içerisindeki arkadaş ilişkileri,
            üstlendikleri roller, benimsedikleri davranış kalıpları, kurallara
            uyum düzeyleri, sosyal becerileri, iletişim yetenekleri, dikkat
            süreleri, sorumluluk alma eğilimleri ve paylaşımcılık gibi çeşitli
            gelişimsel özellikleri değerlendirilmektedir.
            <br />
            <br />
            Gözlemler sonucunda belirlenen ihtiyaçlara göre, bireysel çalışmalar
            planlanmakta ve çocuğa özel destek programları uygulanmaktadır.
            Bunun yanı sıra, öğrenciler yalnızca sınıf içinde değil; bahçe,
            yemekhane ve uyku odası gibi farklı <strong>anaokulu</strong>{" "}
            alanlarında da gözlemlenmektedir. Bu gözlemler, çocukların sosyal
            etkileşimlerini, duygusal durumlarını ve genel davranış örüntülerini
            daha bütüncül bir şekilde değerlendirmemize olanak tanımakta;
            bireysel <strong>çocuk gelişimi</strong> süreçlerini destekleyici
            çalışmalarımıza rehberlik etmektedir.
          </p>
        </div>
        <div className="subPages_hizmetlerimiz-rehberlik_card">
          <h1>Veli Görüşmeleri</h1>
          <p>
            Öğrencilerimizin <strong>çocuk gelişimi</strong> süreçlerini daha
            yakından takip edebilmek amacıyla, velilerimizle düzenli olarak
            bireysel görüşmeler gerçekleştirilmektedir. Bu görüşmelerde,
            uygulanan tarama ve ölçme-değerlendirme çalışmalarından elde edilen
            bulgular ile öğretmen gözlemleri ve geri bildirimler ailelerle
            detaylı şekilde paylaşılmaktadır.
            <br />
            <br />
            Görüşmeler sırasında, çocukların gelişimini desteklemek ve öğrenme
            süreçlerini kalıcı hale getirmek amacıyla velilere çeşitli öneriler
            sunulmakta; aynı zamanda ailelerin de bu sürece aktif olarak katılım
            sağlamaları teşvik edilmektedir. Bu iş birliği sayesinde, çocuğun
            okul ve ev ortamındaki gelişimi bütüncül bir yaklaşımla
            desteklenmektedir.
          </p>
        </div>
        {/* <div className="subPages_hizmetlerimiz-rehberlik_card">
          <h1> Seminer/Eğitimler</h1>
          <p>
            İhtiyaç ve talepler doğrultusunda belirlenen psikolojik konular
            hakkında öğretmenlerimize ve/veya velilerimize seminerler
            düzenlenir.
          </p>
        </div> */}
      </div>
    );
  },
];

export default page;
